import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=13973991&"
import script from "./Orders.vue?vue&type=script&lang=ts&"
export * from "./Orders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports